// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"Agreement_modalContainer__3BI8R","modal-title":"Agreement_modal-title__17gmn"};